export default [
  {
    path: "/ludou/homePageManage",
    component: () => import("@/pages/ludou/homePageManage.vue"),
    name: "homePageManage",
    title: "首页信息配置",
    meta: {
      title: "首页信息配置"
    }
  },
  {
    path: "/ludou/redeemLogManage",
    component: () => import("@/pages/ludou/redeemLogManage.vue"),
    name: "redeemLogManage",
    title: "兑换管理",
    meta: {
      title: "兑换管理"
    }
  },
  {
    path: "/ludou/ludouUserManage",
    component: () => import("@/pages/ludou/ludouUserManage.vue"),
    name: "redeemLogManage",
    title: "麓豆用户管理",
    meta: {
      title: "麓豆用户管理"
    }
  },
  {
    path: "/jifenUserManage",
    component: () => import("@/pages/ludou/jifenUserManage.vue"),
    name: "jifenUserManage",
    title: "积分用户管理",
    meta: {
      title: "积分用户管理"
    }
  },
  {
    path: "/ludou/ludouShopManage",
    component: () => import("@/pages/ludou/ludouShop/ludouShopManage.vue"),
    name: "ludouShopManage",
    title: "麓豆商城管理",
    meta: {
      title: "麓豆商城管理"
    }
  },
  {
    path: "/ludou/ludouShopCate",
    component: () => import("@/pages/ludou/ludouShop/ludouShopCate.vue"),
    name: "ludouShopCate",
    title: "麓豆商品分类",
    meta: {
      title: "麓豆商品分类"
    }
  },
  {
    path: "/ludou/ludouShopOrder",
    component: () => import("@/pages/ludou/ludouShop/ludouShopOrder.vue"),
    name: "ludouShopOrder",
    title: "麓豆订单兑换",
    meta: {
      title: "麓豆订单兑换"
    }
  },
  {
    path: "/ludou/ludouChargeLog",
    component: () => import("@/pages/ludou/ludouChargeLog.vue"),
    name: "ludouChargeLog",
    title: "麓豆订单兑换",
    meta: {
      title: "麓豆订单兑换"
    }
  },
];
